/**
 * Formular zum Absenden einer Rückmeldung an die DIQ Zert GmbH
 * Das Absenden der Rückmeldung selbst läuft über das Back-End
 */

import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Form, FormControl } from 'react-bootstrap';
import { inject, bind } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import { RouteComponentProps } from 'react-router';
import Callout from './Callout';

interface IFeedbackFormRouterProps {
  arbeitsmittelId?: string;
}

@observer
export default class FeedbackForm extends React.Component<RouteComponentProps<IFeedbackFormRouterProps>, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  @observable nachricht: string = '';
  @observable betreff: string = '';
  @observable betreffReadOnly: boolean = false;
  @observable submitted: boolean = false;

  async componentDidMount() {
    if (this.props.match.params.arbeitsmittelId) {
      let arbeitsmittel = await this.apiStore.arbeitsmittelDetail(this.props.match.params.arbeitsmittelId);
      if (arbeitsmittel.ok) {
        this.setBetreff(`Rückmeldung zu "${arbeitsmittel.json.name}" (${arbeitsmittel.json.arbeitsmittelnr})`);
        this.setBetreffReadOnly(true);
      }
    }
  }

  @bind async handleFormSubmit(event: React.FormEvent<FormControl>) {
    event.preventDefault();
    const response = await this.apiStore.rueckmeldung(this.betreff, this.nachricht);
    if (response.ok) {
      this.setSubmitted(true);
    }
  }

  @bind @action setBetreff(value: string) {
    this.betreff = value;
  }

  @bind @action setBetreffReadOnly(value: boolean) {
    this.betreffReadOnly = value;
  }

  @bind @action setSubmitted(value: boolean) {
    this.submitted = value;
  }

  @bind @action handlBetreffChanged(event: React.FormEvent<FormControl>) {
    this.betreff = (event.target as HTMLInputElement).value;
  }

  @bind @action handleNachrichtChanged(event: React.FormEvent<FormControl>) {
    this.nachricht = (event.target as HTMLInputElement).value;
  }

  validate() {
    return (this.nachricht.trim() !== '') && (this.betreff.trim() !== '');
  }

  render() {
    return (
      <div className="maxwidth">
        <h2>Rückmeldung</h2>
        <Form horizontal={true} onSubmit={this.handleFormSubmit}>

          <h4>Betreff</h4>
          <FormControl
            type="text"
            value={this.betreff}
            onChange={this.handlBetreffChanged}
            readOnly={this.betreffReadOnly}
          />
          <h4>Ihre Nachricht</h4>
          <FormControl
            componentClass="textarea"
            type="text"
            rows={8}
            value={this.nachricht}
            onChange={this.handleNachrichtChanged}
          />

          <div className="text-muted" style={{paddingTop: '15px', fontSize: '10pt', lineHeight: '16px'}}>
            Mit Klick auf «Absenden» erklären Sie sich mit der Erhebung, der Übermittlung der Daten per E-Mail sowie einer elektronischen Verarbeitung und Speicherung einverstanden.
            (Dieses Einverständnis ist jederzeit widerrufbar)
            <br/>Bitte beachten Sie auch die <a href="https://www.diq-zert.de/de/datenschutz" target="_blank">Datenschutzerklärung</a>.
          </div>

          {this.submitted ?
            (<Callout bsStyle="success">
              <p>Ihre Rückmeldung wurde erfolgreich an die DIQ Zert GmbH übermittelt.</p>
              <div className="text-right">
                <Button onClick={() => this.uiStore.navigateBack()}>Zurück</Button>
              </div>
            </Callout>)
            :
            (<div className="text-right" style={{paddingTop: '15px'}}>
              <Button onClick={() => this.uiStore.navigateBack()}>Abbrechen</Button>
              <Button bsStyle="primary" disabled={!this.validate()} type="submit">Absenden</Button>
            </div>)
          }

        </Form>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/FeedbackForm.tsx